// extracted by mini-css-extract-plugin
module.exports = {"Title":"FavoriteServices_Title__ZU_nQ","Wrapper":"FavoriteServices_Wrapper__n31M1","Container":"FavoriteServices_Container__1aV-d","Service":"FavoriteServices_Service__a9XYr"};